module.exports = __webpack_public_path__ + "img/delete.dcac5e2c.png";